"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Home = _interopRequireDefault(require("@/components/FormGenerator/index/Home.vue"));
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
var _default = exports.default = {
  // name: "edit"
  components: {
    configList: _Home.default
  },
  props: {
    editData: {
      type: Object,
      default: {}
    },
    isCreate: {
      type: Number,
      default: 0 // 0=创建，1=编辑
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handlerGetFormConfigData: function handlerGetFormConfigData(formConfigData) {
      formConfigData.id ? this.handlerEdit(formConfigData) : this.handlerSave(formConfigData);
    },
    handlerSave: function handlerSave(pram) {
      var _this = this;
      systemFormConfigApi.getFormConfigSave(pram).then(function (data) {
        _this.$message.success('创建表单配置成功');
        setTimeout(function () {
          _this.$emit('hideDialog');
        }, 800);
      });
    },
    handlerEdit: function handlerEdit(pram) {
      var _this2 = this;
      systemFormConfigApi.getFormConfigEdit(pram).then(function (data) {
        _this2.$message.success('编辑表单配置成功');
        setTimeout(function () {
          _this2.$emit('hideDialog');
        }, 800);
      });
    }
  }
};